import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SpsListActionBarComponent } from "../components/index";

@NgModule({
    imports: [CommonModule],
    declarations: [SpsListActionBarComponent],
    exports: [SpsListActionBarComponent],
})
export class SpsListActionBarModule {}
